import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import Button from "../../components/common/Button/Button";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import BarChartGraph from "../../components/common/Charts/BarChartGraph";
import { getApiInstance } from "../../utils/api";
import "./FichaCentroProductor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import CardCharts from "../../components/common/CardCharts/CardCharts";
import InputDropdown from "../../components/common/Inputs/InputDropdown/InputDropdown";
import { useZone } from "../../context/ZoneContext";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { IoTrashOutline } from "react-icons/io5";
import { addOrUpdateRecentItem, mapList } from "../../utils/utils";
import { formatDate } from "../../utils/utils";
import PieChartGraph from "../../components/common/Charts/PieChartGraph";
import { mockTarifas, tarifaOptions } from "./data";

const formatKg = (value) => new Intl.NumberFormat("es-ES").format(value);

export default function FichaCentroProductor({ user }) {
    const { id } = useParams();
    const [centro, setCentro] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [cumplimientoLegal, setCumplimientoLegal] = useState([]);
    const [residuos, setResiduos] = useState(null);
    const [residuosAgrupados, setResiduosAgrupados] = useState([]);
    const [residuosGenerados, setResiduosGenerados] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [activeTabDatos, setActiveTabDatos] = useState("informacion");
    const [activeTabResiduos, setActiveTabResiduos] = useState("cantidades");
    const [activeTabDocumentacion, setActiveTabDocumentacion] =
        useState("documentacion");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
    const { selectedZone } = useZone();
    const [distribuidoras, setDistribuidoras] = useState([]);
    const [consumo, setConsumo] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [transportistas, setTransportistas] = useState([]);
    const [vehiculos, setVehiculos] = useState([]);
    const [combustibles, setCombustibles] = useState([]);
    const [gestores, setGestores] = useState([]);
    const [tiposTratamiento, setTiposTratamiento] = useState([]);
    const [residuosObraGroupped, setResiduosObraGroupped] = useState([]);
    const [datosProcesadosBar, setDatosProcesadosBar] = useState([]);
    const [datosProcesadosPie, setDatosProcesadosPie] = useState([]);
    const [totalCantidadGenerada, setTotalCantidadGenerada] = useState(0);
    const [totalValorizacion, setTotalValoracion] = useState(0);
    const [totalEliminacion, setTotalEliminacion] = useState(0);
    const [porcentajeValorizacion, setPorcentajeValorizacion] = useState(0);
    const [porcentajeEliminacion, setPorcentajeEliminacion] = useState(0);
    const [tiposDocumentosObligatorios, setTiposDocumentosObligatorios] =
        useState([]);
    const [tiposDocumentosNoObligatorios, setTiposDocumentosNoObligatorios] =
        useState([]);

    const formElementsDocumentos = [
        {
            elements: [
                {
                    name: "codTipoDocumento",
                    type: "radio",
                    label: "Tipo de documento",
                    placeholder: "Seleccione el tipo de documento",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: [
                        {
                            label: "Documentación obligatoria",
                            options: tiposDocumentosObligatorios,
                        },
                        {
                            label: "Documentacion no obligatoria",
                            options: tiposDocumentosNoObligatorios,
                        },
                    ],
                },
                {
                    name: "fichero",
                    type: "document",
                    label: "Documento",
                    placeholder: "Subir documento",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "observaciones",
                    type: "textarea",
                    label: "Observaciones",
                    placeholder: "Escriba las observaciones aquí",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codObra",
                    type: "text",
                    label: "Código Obra",
                    placeholder: "",
                    required: false,
                    disabled: true,
                    labelVisible: false,
                    visible: false,
                    defaultValue: id,
                },
            ],
        },
    ];

    useEffect(() => {
        if (centro != null) {
            addOrUpdateRecentItem({
                id: centro.codObra,
                title: centro.nombre,
                type: "centroProductor",
            });
        }
    }, [centro]);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        setError(null);

        const loadAll = async () => {
            try {
                const obra = await fetchCentroProductor(id);

                if (isMounted) {
                    setCentro(obra);
                }

                const residuosGrouped = [];
                obra.residuos.forEach((currentItem) => {
                    const existingGroup = residuosGrouped.find(
                        (group) => group.codResiduo === currentItem.codResiduo
                    );

                    if (existingGroup) {
                        existingGroup.peso += currentItem.peso;
                        existingGroup.costeTotal += currentItem.costeTotal;
                        if (currentItem.valorizacion != null) {
                            existingGroup.pesoConDatoValorizacion +=
                                currentItem.peso;
                            if (existingGroup.valorizacion === null) {
                                existingGroup.valorizacion = 0;
                            }
                            existingGroup.valorizacion +=
                                currentItem.valorizacion;
                        } else {
                            existingGroup.pesoSinDatoValorizacion +=
                                currentItem.peso;
                        }
                    } else {
                        const newGroup = {
                            codResiduo: currentItem.codResiduo,
                            codTipoResiduo: currentItem.codTipoResiduo,
                            residuo:
                                currentItem.residuo.codigo +
                                " - " +
                                currentItem.residuo.nombre,
                            peso: currentItem.peso,
                            pesoConDatoValorizacion:
                                currentItem.valorizacion != null
                                    ? currentItem.peso
                                    : 0,
                            pesoSinDatoValorizacion:
                                currentItem.valorizacion == null
                                    ? currentItem.peso
                                    : 0,
                            valorizacion: currentItem.valorizacion,
                            costeTotal: currentItem.costeTotal,
                        };
                        residuosGrouped.push(newGroup);
                    }
                });

                const agregadosBar = obra.residuos.reduce((acc, item) => {
                    const residuoKey = `${item.residuo.codigo} - ${item.residuo.nombre}`;
                    if (!acc[residuoKey]) {
                        acc[residuoKey] = { valorizado: 0, eliminado: 0 };
                    }
                    acc[residuoKey].valorizado += item.valorizacion || 0;
                    acc[residuoKey].eliminado += item.eliminacion || 0;
                    return acc;
                }, {});

                const datosProcesadosBar = Object.keys(agregadosBar).map(
                    (residuo) => ({
                        name: residuo,
                        Valorización: agregadosBar[residuo].valorizado,
                        Eliminación: agregadosBar[residuo].eliminado,
                    })
                );

                const totalValorizado = obra.residuos.reduce(
                    (sum, item) => sum + (item.valorizacion || 0),
                    0
                );
                const totalEliminado = obra.residuos.reduce(
                    (sum, item) => sum + (item.eliminacion || 0),
                    0
                );
                const granTotal = totalValorizado + totalEliminado;
                const porcVal =
                    granTotal > 0 ? (totalValorizado / granTotal) * 100 : 0;
                const porcElim =
                    granTotal > 0 ? (totalEliminado / granTotal) * 100 : 0;

                const datosProcesadosPie = [
                    {
                        name: "Valorización",
                        value: parseFloat(porcVal.toFixed(2)),
                    },
                    {
                        name: "Eliminación",
                        value: parseFloat(porcElim.toFixed(2)),
                    },
                ];

                if (isMounted) {
                    setResiduosObraGroupped(residuosGrouped);
                    setDatosProcesadosBar(datosProcesadosBar);
                    setDatosProcesadosPie(datosProcesadosPie);
                    setTotalCantidadGenerada(granTotal);
                    setTotalValoracion(totalValorizado);
                    setTotalEliminacion(totalEliminado);
                    setPorcentajeValorizacion(porcVal);
                    setPorcentajeEliminacion(porcElim);
                }

                const results = await Promise.allSettled([
                    fetchDocumentosCentroProductor(id),
                    fetchElectricas(),
                    fetchConsumo(id),
                    fetchResiduos(),
                    fetchProyectos(),
                    fetchResiduosTiposTratamiento(),
                    fetchTiposVehiculos(),
                    fetchTiposCombustible(),
                    fetchImagenes(id),
                    fetchTarifas(id),
                    fetchTiposDocumentos(),
                ]);

                const [
                    documentosResult,
                    electricasResult,
                    consumoResult,
                    residuosResult,
                    proyectosResult,
                    tiposTratamientoResult,
                    vehiculosResult,
                    combustiblesResult,
                    imagenesResult,
                    tarifasResult,
                    tiposDocumentosResult,
                ] = results;

                if (isMounted) {
                    if (documentosResult.status === "fulfilled") {
                        setDocumentos(documentosResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar los documentos:",
                            documentosResult.reason
                        );
                    }

                    if (electricasResult.status === "fulfilled") {
                        setDistribuidoras(
                            mapList(
                                electricasResult.value,
                                "nombre",
                                "codElectrica"
                            )
                        );
                    } else {
                        console.warn(
                            "No se pudieron cargar las eléctricas:",
                            electricasResult.reason
                        );
                    }

                    if (consumoResult.status === "fulfilled") {
                        setConsumo(consumoResult.value);
                    } else {
                        console.warn(
                            "No se pudo cargar el consumo:",
                            consumoResult.reason
                        );
                    }

                    if (residuosResult.status === "fulfilled") {
                        setResiduos([
                            ...mapList(
                                residuosResult.value,
                                "nombre",
                                "codResiduo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los residuos:",
                            residuosResult.reason
                        );
                    }

                    if (proyectosResult.status === "fulfilled") {
                        setProyectos([
                            ...mapList(
                                proyectosResult.value,
                                "proyecto",
                                "codProyecto"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los proyectos:",
                            proyectosResult.reason
                        );
                    }

                    const proveedores = await fetchProveedores();

                    setTransportistas([
                        ...mapList(
                            proveedores.filter(
                                (x) => x.isTransportista && x.codEstado == 3
                            ),
                            "nombre",
                            "codProveedor",
                            "codResiduo",
                            "codsResiduos"
                        ),
                    ]);
                    setGestores([
                        ...mapList(
                            proveedores.filter(
                                (x) => x.isGestorFinal && x.codEstado == 3
                            ),
                            "nombre",
                            "codProveedor",
                            "codResiduo",
                            "codsResiduos"
                        ),
                    ]);

                    if (tiposTratamientoResult.status === "fulfilled") {
                        setTiposTratamiento([
                            ...mapList(
                                tiposTratamientoResult.value,
                                ["codigo", "descripcion"],
                                "codTipoTratamiento",
                                "codTipoTratamiento",
                                "tipo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de tratamiento:",
                            tiposTratamientoResult.reason
                        );
                    }

                    if (vehiculosResult.status === "fulfilled") {
                        setVehiculos([
                            ...mapList(
                                vehiculosResult.value,
                                "vehiculo",
                                "codVehiculo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de vehículos:",
                            vehiculosResult.reason
                        );
                    }

                    if (combustiblesResult.status === "fulfilled") {
                        setCombustibles([
                            ...mapList(
                                combustiblesResult.value,
                                "combustible",
                                "codCombustible",
                                "codVehiculo",
                                "codsVehiculo"
                            ),
                        ]);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos de combustible:",
                            combustiblesResult.reason
                        );
                    }

                    if (imagenesResult.status === "fulfilled") {
                        setImagenes(imagenesResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar las imágenes:",
                            imagenesResult.reason
                        );
                    }

                    if (tarifasResult.status === "fulfilled") {
                        setTarifas(tarifasResult.value);
                    } else {
                        console.warn(
                            "No se pudieron cargar las imágenes:",
                            tarifasResult.reason
                        );
                    }

                    if (tiposDocumentosResult.status === "fulfilled") {
                        const tiposDocObligatorios =
                            tiposDocumentosResult.value.filter(
                                (doc) => doc.obligatorio
                            );
                        const tiposDocNoObligatorios =
                            tiposDocumentosResult.value.filter(
                                (doc) => !doc.obligatorio
                            );
                        setTiposDocumentosObligatorios([
                            ...mapList(
                                tiposDocObligatorios,
                                "descripcion",
                                "codTipoDocumento"
                            ),
                        ]);
                        setTiposDocumentosNoObligatorios([
                            ...mapList(
                                tiposDocNoObligatorios,
                                "descripcion",
                                "codTipoDocumento"
                            ),
                        ]);
                        console.log(tiposDocObligatorios);
                        console.log(tiposDocNoObligatorios);
                    } else {
                        console.warn(
                            "No se pudieron cargar los tipos documento:",
                            tiposDocumentosResult.reason
                        );
                    }
                }
            } catch (err) {
                if (isMounted) {
                    setError(
                        "No se han podido cargar los datos principales. Vuelve a intentarlo más tarde."
                    );
                }
                console.error("Error en datos críticos de loadAll:", err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadAll();

        return () => {
            isMounted = false;
        };
    }, [id, selectedZone]);

    const fetchCentroProductor = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Obra/GetObra/${selectedZone.value}/1/${id}/es`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchDocumentosCentroProductor = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ObraDocumento/GetDocumentosFromObra/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchConsumo = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Consumo/GetConsumoByCodObra/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchElectricas = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Electrica/GetAllElectricas`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchResiduos = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                `/api/Residuos/GetResiduosByZona/?codZona=${selectedZone.value}`
            );
            console.log("Residuos fetched:", response.data);
            return await response.data;
        } catch (err) {
            setError(
                "No se han podido cargar los residuos. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        }
    };

    const fetchProyectos = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Proyecto/GetProyectos`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching proyectos:", error);
            throw error;
        }
    };

    const fetchProveedores = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Proveedores/GetProveedoresLiteByZona/?CodZona=${selectedZone.value}&CodZonaLegal=1`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching proyectos:", error);
            throw error;
        }
    };

    const fetchResiduosTiposTratamiento = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ResiduosTipoTratamiento/GetResiduosTipoTratamiento/${selectedZone.value}/es`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos tratamiento:", error);
            throw error;
        }
    };

    const fetchTiposVehiculos = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Huella/GetTiposVehiculo`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos vehiculos:", error);
            throw error;
        }
    };

    const fetchTiposCombustible = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Huella/GetTiposCombustible`);
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos combustible:", error);
            throw error;
        }
    };

    const fetchImagenes = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Obra/GetImagenesObra/${id}`);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchTarifas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasAsignadasByObra/${id}`
            );

            console.log("Tarifas fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchTarifasProveedores = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasAsignadasByObra/${id}`
            );

            console.log("Tarifas fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching imágenes:", error);
            throw error;
        }
    };

    const fetchTiposDocumentos = async () => {
        try {
            // Productor = 1,
            // Gestor = 2,
            // Obra = 3,
            const api = getApiInstance();
            const response = await api.get(
                `/api/Documentos/GetTiposDocumentosByTipoEntidad/3/${selectedZone.value}`
            );

            console.log("Tipos Documentos fetched:", response.data);

            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos documentos:", error);
            throw error;
        }
    };

    const handleTarifaChange = (id, nuevaTarifa) => {
        setTarifas((prevTarifas) =>
            prevTarifas.map((tarifa) =>
                tarifa.id === id ? { ...tarifa, tarifa: nuevaTarifa } : tarifa
            )
        );
    };

    const handleDropdownOpenChange = (rowId, isOpen) => {
        setOpenDropdownRowId(isOpen ? rowId : null);
    };

    const tabsDatos = [
        { id: "informacion", label: "Información General" },
        { id: "ubicacion", label: "Ubicación" },
    ];

    const tabsResiduos = [
        { id: "cantidades", label: "Cantidades generadas" },
        { id: "agrupados", label: "Residuos generados agrupados" },
        { id: "generados", label: "Residuos generados" },
        { id: "tarifas", label: "Tarifas" },
    ];

    const tabsDocumentacion = [
        { id: "documentacion", label: "Documentación" },
        { id: "cumplimiento", label: "Cumplimiento legal" },
        { id: "imagenes", label: "Imágenes" },
    ];

    const renderInformacionGeneral = () => (
        <div className="ficha-centro__info">
            <div className="ficha-centro__field">
                <label>Código Centro:</label>
                <span>{centro.nombre || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Código Espacio:</label>
                <span>{centro.codEspacio || "'"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Tipo Centro:</label>
                <span>{centro.tipoObra || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>NIMA:</label>
                <span>{centro.nima || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Cadena:</label>
                <span>{centro.cadena || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Fecha inicio:</label>
                <span>{formatDate(centro.fechaInicio) || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Fecha fin:</label>
                <span>{formatDate(centro.fechaFin) || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Intermediario:</label>
                <span>{centro.intermediario || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Responsable:</label>
                <span>{centro.responsable || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Superficie:</label>
                <span>{centro.superficie || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Observaciones:</label>
                <span>{centro.observaciones || "-"}</span>
            </div>
        </div>
    );

    const renderUbicacion = () => (
        <div className="ficha-centro__info">
            <div className="ficha-centro__field">
                <label>Ubicación:</label>
                <span>{centro.ubicacion || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Dirección:</label>
                <span>{centro.direccion || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Localidad:</label>
                <span>{centro.localidad || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Provincia:</label>
                <span>{centro.provincia.provincia || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>Comunidad:</label>
                <span>{centro.comunidad || "-"}</span>
            </div>
            <div className="ficha-centro__field">
                <label>País:</label>
                <span>{centro.pais || "-"}</span>
            </div>
        </div>
    );

    const renderDatosContent = () => {
        switch (activeTabDatos) {
            case "informacion":
                return renderInformacionGeneral();
            case "ubicacion":
                return renderUbicacion();
            default:
                return renderInformacionGeneral();
        }
    };

    const renderCantidadesGeneradas = () => (
        <div className="cantidades-generadas-content">
            <div className="graficas-card">
                <div className="charts-section">
                    <div className="chart-container bar-chart-container">
                        <div className="chart-header">
                            <h3>Cantidad generada por Residuo</h3>
                            <div className="total-amount">
                                {formatKg(totalCantidadGenerada)} kg
                            </div>
                        </div>
                        <div className="chart-wrapper">
                            <BarChartGraph
                                data={{ all: datosProcesadosBar }}
                                activeTab="all"
                            />
                        </div>
                    </div>

                    <div className="chart-container pie-chart-container">
                        <div className="chart-header">
                            <h3>Cantidad generada</h3>
                        </div>
                        <div className="chart-wrapper">
                            <PieChartGraph
                                data={{ all: datosProcesadosPie }}
                                activeTab="all"
                            />
                        </div>
                        <div className="pie-legend">
                            <div className="pie-details">
                                <div className="detail-line">
                                    <span>
                                        Eliminación:{" "}
                                        {formatKg(totalEliminacion)} kg. (
                                        {porcentajeEliminacion} %)
                                    </span>
                                </div>
                                <div className="detail-line">
                                    <span>
                                        Valorización:{" "}
                                        {formatKg(totalValorizacion)} kg. (
                                        {porcentajeValorizacion} %)
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderResiduosContent = () => {
        switch (activeTabResiduos) {
            case "cantidades":
                return renderCantidadesGeneradas();
            case "agrupados":
                return (
                    <Table
                        columns={[
                            {
                                key: "residuo",
                                label: "Residuo",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "peso",
                                label: "Peso",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "valorizacion",
                                label: "Valorización",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "costeTotal",
                                label: "Coste total",
                                visible: true,
                                sortable: true,
                                render: (row) => (
                                    <span
                                        className={`coste ${
                                            row.costeTotal < 0
                                                ? "coste--negative"
                                                : "coste--positive"
                                        }`}
                                    >
                                        {row.costeTotal}
                                    </span>
                                ),
                            },
                        ]}
                        dataTable={residuosObraGroupped}
                        noResultsMessage="No hay residuos agrupados disponibles"
                        rowsPerPage={10}
                        keyProp="codResiduo"
                        sortProp="residuo"
                        showCheckboxes={false}
                        elementName="residuo"
                        stateProp="estado"
                        loading={false}
                    />
                );
            case "generados":
                return (
                    <Table
                        columns={[
                            {
                                key: ["residuo/codigo", "residuo/nombre"],
                                label: "Residuo",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "fechaTransporte",
                                label: "Fecha recogida",
                                visible: true,
                                sortable: true,
                                type: "date",
                            },
                            {
                                key: "peso",
                                label: "Peso",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "valorizacion",
                                label: "Valorización",
                                visible: true,
                                sortable: true,
                                render: (row) => {
                                    if (
                                        row.porcentajeValorizacion === 0 ||
                                        row.porcentajeValorizacion === null
                                    ) {
                                        return <span>Sin datos</span>;
                                    }

                                    const obtenerEstiloDeProgreso = (
                                        valor,
                                        maximo
                                    ) => {
                                        if (maximo === 0) {
                                            return {
                                                "--progress-color": "#f44336",
                                            };
                                        }

                                        const porcentaje =
                                            (valor / maximo) * 100;
                                        let color;

                                        if (porcentaje < 40) {
                                            color = "#f44336";
                                        } else if (porcentaje < 75) {
                                            color = "#ff9800";
                                        } else {
                                            color = "#4caf50";
                                        }

                                        return { "--progress-color": color };
                                    };

                                    return (
                                        <div className="valorizacion-container">
                                            <span htmlFor="valorizacion">
                                                {row.peso} / {row.valorizacion}{" "}
                                                {row.unidadPeso}
                                            </span>
                                            <progress
                                                id="valorizacion"
                                                value={row.valorizacion}
                                                max={row.peso}
                                                className="progress-bar"
                                                style={obtenerEstiloDeProgreso(
                                                    row.valorizacion,
                                                    row.peso
                                                )}
                                            ></progress>
                                        </div>
                                    );
                                },
                            },
                            {
                                key: "costeTotal",
                                label: "Coste final",
                                visible: true,
                                sortable: true,
                                render: (row) => (
                                    <span
                                        className={`coste ${
                                            row.costeTotal < 0
                                                ? "coste--negative"
                                                : "coste--positive"
                                        }`}
                                    >
                                        {row.costeTotal}
                                    </span>
                                ),
                            },
                            {
                                key: "codEstado",
                                label: "Validación",
                                visible: true,
                                sortable: true,
                            },
                        ]}
                        dataTable={centro.residuos}
                        noResultsMessage="No hay residuos generados disponibles"
                        rowsPerPage={10}
                        showCheckboxes={false}
                        actions={["Editar", "Eliminar"]}
                        elementName="Residuo"
                        sortProp="codResiduoObra"
                        stateProp="codEstado"
                        states={[
                            {
                                label: "Sin datos",
                                type: "info",
                                Icon: CiClock1,
                            },
                            {
                                label: "Sin datos",
                                type: "info",
                                Icon: CiClock1,
                            },
                        ]}
                        keyProp="codResiduoObra"
                        formElements={[
                            {
                                title: "Residuo",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "codResiduo",
                                        type: "select",
                                        label: "Tipo de residuo",
                                        placeholder:
                                            "Seleccione el tipo de residuo",
                                        required: true,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: residuos,
                                    },
                                    {
                                        name: "codProyecto",
                                        type: "select",
                                        label: "Proyecto",
                                        placeholder: "Seleccione proyecto",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: proyectos,
                                    },
                                    {
                                        name: "codObra",
                                        type: "text",
                                        label: "CodObra",
                                        placeholder: "Inserte codObra",
                                        required: true,
                                        disabled: false,
                                        labelVisible: false,
                                        visible: false,
                                        defaultValue: centro.codObra,
                                    },
                                ],
                            },
                            {
                                title: "Transporte",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "codTransportista",
                                        type: "select",
                                        label: "Transportista",
                                        placeholder:
                                            "Seleccione el transportista",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: transportistas,
                                        associatedFormElement: "codResiduo",
                                    },
                                    {
                                        name: "fechaTransporte",
                                        type: "date",
                                        label: "Fecha transporte",
                                        placeholder:
                                            "Seleccione la fecha de transporte",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "tipoVehiculo",
                                        type: "select",
                                        label: "Tipo de vehículo",
                                        placeholder:
                                            "Seleccione el tipo de vehículo",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: vehiculos,
                                    },
                                    {
                                        name: "tipoCombustible",
                                        type: "select",
                                        label: "Tipo de combustible",
                                        placeholder:
                                            "Seleccione el tipo de combustible",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: combustibles,
                                        associatedFormElement: "tipoVehiculo",
                                    },
                                    {
                                        name: "numKm",
                                        type: "number",
                                        label: "Número de Km",
                                        placeholder:
                                            "Ingrese el número de kilómetros",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "numViajes",
                                        type: "number",
                                        label: "Número de viajes",
                                        placeholder:
                                            "Ingrese el número de viajes",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "ficheroTransportista",
                                        type: "document",
                                        label: "Documento transporte",
                                        placeholder:
                                            "Seleccione el documento de transporte",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                ],
                            },
                            {
                                title: "Gestión intermedia",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "codGestorIntermedio",
                                        type: "select",
                                        label: "Gestor intermedio",
                                        placeholder:
                                            "Seleccione el gestor intermedio",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: gestores,
                                        associatedFormElement: "codResiduo",
                                    },
                                    {
                                        name: "fechaGestionIntermedio",
                                        type: "date",
                                        label: "Fecha gestión intermedio",
                                        placeholder:
                                            "Seleccione la fecha de gestión intermedio",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "tipoTratamiento",
                                        type: "select",
                                        label: "Tipo de tratamiento",
                                        placeholder:
                                            "Seleccione el tipo de tratamiento",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: [
                                            {
                                                value: "Eliminación",
                                                label: "Eliminación",
                                            },
                                            {
                                                value: "Valorización",
                                                label: "Valorización",
                                            },
                                        ],
                                    },
                                    {
                                        name: "codTipoTratamiento",
                                        type: "select",
                                        label: "Descripción tipo tratamiento",
                                        placeholder:
                                            "Ingrese la descripción del tipo de tratamiento",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: tiposTratamiento,
                                        associatedFormElement:
                                            "tipoTratamiento",
                                    },
                                    {
                                        name: "porcentaje",
                                        type: "number",
                                        label: "Porcentaje",
                                        placeholder: "Ingrese el porcentaje",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                ],
                            },
                            {
                                title: "Gestión final",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "codGestorFinal",
                                        type: "select",
                                        label: "Gestor final",
                                        placeholder:
                                            "Seleccione el gestor final",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: gestores,
                                        associatedFormElement: "codResiduo",
                                    },
                                    {
                                        name: "fechaGestionFinal",
                                        type: "date",
                                        label: "Fecha gestión final",
                                        placeholder:
                                            "Seleccione la fecha de gestión final",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "tipoTratamiento2",
                                        type: "select",
                                        label: "Tipo de tratamiento",
                                        placeholder:
                                            "Seleccione el tipo de tratamiento",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: [
                                            {
                                                value: "Eliminación",
                                                label: "Eliminación",
                                            },
                                            {
                                                value: "Valorización",
                                                label: "Valorización",
                                            },
                                        ],
                                    },
                                    {
                                        name: "codTipoTratamiento2",
                                        type: "select",
                                        label: "Descripción tipo tratamiento",
                                        placeholder:
                                            "Ingrese la descripción del tipo de tratamiento",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                        options: tiposTratamiento,
                                        associatedFormElement:
                                            "tipoTratamiento2",
                                    },
                                    {
                                        name: "porcentaje2",
                                        type: "number",
                                        label: "Porcentaje",
                                        placeholder: "Ingrese el porcentaje",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "ficheroGestorFinal",
                                        type: "document",
                                        label: "Documento gestor final",
                                        placeholder:
                                            "Seleccione el documento del gestor final",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                ],
                            },
                            {
                                title: "Cantidades generadas",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "peso",
                                        type: "number",
                                        label: "Peso (KG)",
                                        placeholder: "Ingrese el peso",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "volumen",
                                        type: "number",
                                        label: "Volumen (m3)",
                                        placeholder: "Ingrese el volumen",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                ],
                            },
                            {
                                title: "Coste",
                                titleVisible: true,
                                elements: [
                                    {
                                        name: "transporte",
                                        type: "number",
                                        label: "Transporte",
                                        placeholder:
                                            "Ingrese el coste de transporte",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "gestion",
                                        type: "number",
                                        label: "Gestión",
                                        placeholder:
                                            "Ingrese el coste de gestión",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "colocacionContenedor",
                                        type: "number",
                                        label: "Colocación contenedor",
                                        placeholder:
                                            "Ingrese el coste de colocación de contenedor",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "alquilerContenedor",
                                        type: "number",
                                        label: "Alquiler contenedor",
                                        placeholder:
                                            "Ingrese el coste de alquiler de contenedor",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                    {
                                        name: "generacionDocumento",
                                        type: "number",
                                        label: "Generación documento",
                                        placeholder:
                                            "Ingrese el coste de generación de documento",
                                        required: false,
                                        disabled: false,
                                        labelVisible: true,
                                        visible: true,
                                    },
                                ],
                            },
                        ]}
                        addApiUrl="/api/ResiduosObra/SetResiduoObra"
                        editApiUrl="/api/ResiduosObra/UpdateResiduoObra"
                        deleteApiUrl="/api/ResiduosObra/DeleteResiduoObra"
                        searchTerms={[
                            "residuo",
                            "fechaRecogida",
                            "peso",
                            "costeFinal",
                        ]}
                        loading={loading}
                        userCodAcceso={Number(user.codAcceso)}
                        userCodPerfil={Number(user.role)}
                    />
                );
            case "tarifas":
                return (
                    <Table
                        columns={[
                            {
                                key: "gestor",
                                label: "Gestor",
                                visible: true,
                                sortable: true,
                            },
                            {
                                key: "tarifa",
                                label: "Tarifa",
                                visible: true,
                                sortable: false,
                                render: (row) => (
                                    <InputDropdown
                                        options={tarifaOptions}
                                        defaultValue={
                                            tarifaOptions.find(
                                                (opt) =>
                                                    opt.label === row.tarifa ||
                                                    (row.tarifa ===
                                                        "Sin asignar" &&
                                                        opt.value ===
                                                            "sin_tarifa")
                                            ) || {
                                                value: "sin_tarifa",
                                                label: "Sin tarifa",
                                            }
                                        }
                                        onChange={(selectedOption) =>
                                            handleTarifaChange(
                                                row.id,
                                                selectedOption?.label ||
                                                    "Sin tarifa"
                                            )
                                        }
                                        onOpenChange={(isOpen) =>
                                            handleDropdownOpenChange(
                                                row.id,
                                                isOpen
                                            )
                                        }
                                        placeholder="Seleccionar tarifa"
                                        disabled={false}
                                        tableMode={true}
                                    />
                                ),
                            },
                        ]}
                        dataTable={tarifas}
                        noResultsMessage="No hay tarifas disponibles"
                        rowsPerPage={10}
                        showCheckboxes={false}
                        elementName="tarifa"
                        stateProp="tarifa"
                        loading={loading}
                    />
                );
            default:
                return renderCantidadesGeneradas();
        }
    };

    const renderImagenes = () => {
        const handleEliminarImagen = async (imagenId, fileName, codObra) => {
            console.log("Eliminar imagen:", imagenId, fileName, codObra);

            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar esta imagen?"
                )
            ) {
                try {
                    const api = getApiInstance();
                    await api.delete(
                        `/api/Obra/DeleteImagen/${imagenId}/${codObra}/${fileName}`
                    );
                    setImagenes(
                        imagenes.filter((img) => img.codImagen !== imagenId)
                    );
                } catch (error) {
                    console.error("Error eliminando imagen:", error);
                    alert("Error al eliminar la imagen. Inténtalo de nuevo.");
                }
            }
        };

        const handleSubirImagenes = async (e) => {
            const files = e.target.files;
            if (!files || files.length === 0) return;

            try {
                const api = getApiInstance();
                const formData = new FormData();

                for (const file of files) {
                    formData.append("Imagenes", file);
                }

                const { data } = await api.post(
                    `/api/Obra/SetImage/${id}`,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                const imagenesActualizadas = await fetchImagenes(id);
                setImagenes(imagenesActualizadas);
            } catch (error) {
                console.error("Error subiendo imágenes:", error);
                alert("Error al subir las imágenes. Inténtalo de nuevo.");
            } finally {
                // Resetea el input para poder volver a seleccionar el mismo archivo si se desea
                e.target.value = "";
            }
        };

        const formatearFecha = (fechaString) => {
            const fecha = new Date(fechaString);
            const dia = String(fecha.getDate()).padStart(2, "0");
            const mes = String(fecha.getMonth() + 1).padStart(2, "0");
            const año = fecha.getFullYear();
            const horas = String(fecha.getHours()).padStart(2, "0");
            const minutos = String(fecha.getMinutes()).padStart(2, "0");
            const segundos = String(fecha.getSeconds()).padStart(2, "0");
            return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
        };

        if (!imagenes || imagenes.length === 0) {
            return (
                <div className="imagenes-section">
                    <div className="imagenes-upload-area">
                        <div className="imagenes-upload-content">
                            <p>Haz click aquí para subir imágenes</p>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleSubirImagenes}
                                style={{ display: "none" }}
                                id="upload-imagenes"
                            />
                            <label
                                htmlFor="upload-imagenes"
                                className="upload-label"
                            >
                                Seleccionar archivos
                            </label>
                        </div>
                    </div>
                    <div className="imagenes-empty">
                        <p>Actualmente no hay imágenes para mostrar</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="imagenes-section">
                <div className="imagenes-upload-area">
                    <div className="imagenes-upload-content">
                        <p>Haz click aquí para subir imágenes</p>
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleSubirImagenes}
                            style={{ display: "none" }}
                            id="upload-imagenes"
                        />
                        <label
                            htmlFor="upload-imagenes"
                            className="upload-label"
                        >
                            Seleccionar archivos
                        </label>
                    </div>
                </div>
                <div className="imagenes-grid">
                    {imagenes.map((imagen) => (
                        <div key={imagen.codImagen} className="imagen-card">
                            <div className="imagen-thumbnail">
                                <img
                                    src={`data:image/png;base64,${imagen.fileBase64}`}
                                    alt={`Imagen ${imagen.codImagen}`}
                                />
                            </div>
                            <div className="imagen-info">
                                <div className="imagen-detalles">
                                    <p className="imagen-usuario">
                                        {imagen.usuario || "Usuario"}
                                    </p>
                                    <p className="imagen-fecha">
                                        {formatearFecha(imagen.fechaSubida)}
                                    </p>
                                </div>
                                <button
                                    className="eliminar-imagen-btn"
                                    onClick={() =>
                                        handleEliminarImagen(
                                            imagen.codImagen,
                                            imagen.fileName,
                                            id
                                        )
                                    }
                                    aria-label="Eliminar imagen"
                                    title="Eliminar imagen"
                                >
                                    <IoTrashOutline />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderDocumentacionContent = () => {
        switch (activeTabDocumentacion) {
            case "documentacion":
                return (
                    <div className="ficha-centro__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    documentProp: "ficheroBase64",
                                    type: "document",
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Eliminar"]}
                            elementName="Documento"
                            keyProp="codDocumento"
                            stateProp="codEstado"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente de validar",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validación con incidencias",
                                    type: "danger",
                                    Icon: CgDanger,
                                },
                                {
                                    label: "Validada",
                                    type: "success",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "approved", label: "Aprobado" },
                                { value: "pending", label: "Pendiente" },
                                { value: "rejected", label: "Rechazado" },
                            ]}
                            stateChangeUrl="/api/gestores/change-status"
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/ObraDocumento/SetDocumento"
                            deleteApiUrl="/api/ObraDocumento/DeleteDocumento"
                            loading={loading}
                        />
                    </div>
                );
            case "cumplimiento":
                return (
                    <div className="ficha-centro__cumplimiento">
                        <Table
                            columns={[
                                {
                                    key: "nombre",
                                    label: "Descripción",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "codEstado",
                                    label: "Estado",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={centro.cumplimientos}
                            noResultsMessage="No hay datos de cumplimiento legal disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            elementName="Cumplimiento"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Sin validar",
                                    type: "warning",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validado",
                                    type: "success",
                                    Icon: CiClock1,
                                },
                            ]}
                            stateProp="codEstado"
                            sortProp="descripcion"
                            loading={loading}
                        />
                    </div>
                );
            case "imagenes":
                return renderImagenes();
            default:
                return (
                    <div className="ficha-centro__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    documentProp: "ficheroBase64",
                                    type: "document",
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Editar", "Eliminar"]}
                            elementName="Documento"
                            stateProp="codEstado"
                            states={[
                                {
                                    label: "Sin datos",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Pendiente de validar",
                                    type: "info",
                                    Icon: CiClock1,
                                },
                                {
                                    label: "Validación con incidencias",
                                    type: "danger",
                                    Icon: CgDanger,
                                },
                                {
                                    label: "Validada",
                                    type: "success",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/gestores/documentos"
                            editApiUrl="/api/gestores/documentos"
                            deleteApiUrl="/api/gestores/documentos"
                            loading={false}
                        />
                    </div>
                );
        }
    };

    const renderConsumo = () => (
        <Table
            columns={[
                {
                    key: "electrica",
                    label: "Eléctrica",
                    visible: true,
                    sortable: true,
                },
                {
                    key: "fechaInicio",
                    label: "Fecha inicio",
                    visible: true,
                    sortable: true,
                    type: "date",
                },
                {
                    key: "fechaFin",
                    label: "Fecha fin",
                    visible: true,
                    sortable: true,
                    type: "date",
                },
                {
                    key: "consumo",
                    label: "Consumo",
                    visible: true,
                    sortable: true,
                },
                {
                    key: "factura",
                    label: "Factura",
                    visible: true,
                    sortable: true,
                    type: "document",
                    documentProp: "ficheroBase64",
                },
            ]}
            dataTable={consumo}
            noResultsMessage="No hay datos de consumo disponibles"
            rowsPerPage={10}
            showCheckboxes={false}
            elementName="Consumo"
            sortProp="electrica"
            keyProp="codConsumo"
            actions={["Eliminar", "Editar"]}
            loading={loading}
            formElements={[
                {
                    elements: [
                        {
                            name: "codObra",
                            type: "text",
                            required: false,
                            disabled: false,
                            visible: false,
                            defaultValue: `${id}`,
                        },
                        {
                            name: "codElectrica",
                            type: "select",
                            label: "Distribuidora",
                            placeholder: "Seleccione una distribuidora",
                            options: distribuidoras,
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "codGarantia",
                            type: "select",
                            label: "Garantía de Origen (GDO)",
                            placeholder:
                                "¿Dispone de Garantía de Origen (GDO)?",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                            options: [
                                { value: "1", label: "GdO energía renovable" },
                                {
                                    value: "2",
                                    label: "GdO cogeneración de alta eficiencia",
                                },
                                { value: "3", label: "No" },
                            ],
                        },
                        {
                            name: "fechaInicio",
                            type: "date",
                            label: "Fecha Inicio",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "fechaFin",
                            type: "date",
                            label: "Fecha Fin",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "consumo",
                            type: "number",
                            label: "Consumo (kWh)",
                            placeholder: "Ingrese el consumo en kWh",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                        {
                            name: "FicheroFactura",
                            type: "document",
                            label: "Factura",
                            placeholder: "Subir factura",
                            required: true,
                            disabled: false,
                            labelVisible: true,
                            visible: true,
                        },
                    ],
                },
            ]}
            addApiUrl="/api/Consumo/SetConsumo"
            editApiUrl="/api/Consumo/EditConsumo"
            deleteApiUrl="/api/Consumo/DeleteConsumo"
        />
    );

    return (
        <DetalleLayout
            title={
                centro
                    ? `Centro ${centro.codEspacio} - ${centro.direccion} -${centro.localidad}`
                    : "Cargando..."
            }
            backLink="/centros-productores"
            backText="Volver a Centros"
            loading={loading}
            error={error}
            notFound={!centro && !loading && !error}
            className="ficha-centro"
        >
            {!loading && !error && centro && (
                <div className="ficha-centro__content">
                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Datos del centro</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsDatos}
                            activeTab={activeTabDatos}
                            onTabChange={setActiveTabDatos}
                        />
                        <div className="ficha-centro__section-content">
                            {renderDatosContent()}
                        </div>
                    </div>
                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Residuos</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsResiduos}
                            activeTab={activeTabResiduos}
                            onTabChange={setActiveTabResiduos}
                        />
                        <div className="ficha-centro__section-content">
                            {renderResiduosContent()}
                        </div>
                    </div>

                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Documentación</h2>
                        </div>
                        <TabsNavigation
                            tabs={tabsDocumentacion}
                            activeTab={activeTabDocumentacion}
                            onTabChange={setActiveTabDocumentacion}
                        />
                        <div className="ficha-centro__section-content">
                            {renderDocumentacionContent()}
                        </div>
                    </div>

                    <div className="ficha-centro__section">
                        <div className="ficha-centro__section-header">
                            <h2>Consumo</h2>
                        </div>
                        <div className="ficha-centro__section-content">
                            {renderConsumo()}
                        </div>
                    </div>
                </div>
            )}
        </DetalleLayout>
    );
}
